// Habano wordmark — rounded-square gold-cornered frame around the H monogram
// + serif gold wordmark "HABANO" with "APP" tag below.

import { Monogram } from "./Monogram";

/** Boxed monogram — H inside a rounded-square gold frame (per mockup) */
export function MonogramBoxed({ size = 56, className = "" }) {
  const inner = Math.round(size * 0.62);
  return (
    <span
      className={`relative inline-grid place-items-center ${className}`}
      style={{
        width: size,
        height: size,
        borderRadius: Math.round(size * 0.32),
        background:
          "linear-gradient(180deg, rgba(20,19,18,1) 0%, rgba(11,10,9,1) 100%)",
        border: "1px solid rgba(200, 160, 99, 0.35)",
        boxShadow:
          "inset 0 1px 0 rgba(255,255,255,0.04), 0 8px 24px rgba(200, 160, 99, 0.08)",
      }}
    >
      <Monogram size={inner} />
    </span>
  );
}

const SIZE_MAP = { xs: 22, sm: 28, md: 34, lg: 44, xl: 64 };

export const Logo = ({ size = "md", tag = true, className = "", ...rest }) => {
  const mono = SIZE_MAP[size] || 34;
  const scales = {
    xs: { text: "text-base", tag: "text-[9px]" },
    sm: { text: "text-lg",   tag: "text-[10px]" },
    md: { text: "text-2xl",  tag: "text-[10px]" },
    lg: { text: "text-3xl",  tag: "text-xs" },
    xl: { text: "text-5xl",  tag: "text-sm" },
  };
  const s = scales[size] || scales.md;
  return (
    <div className={`inline-flex flex-col items-center gap-3 ${className}`} {...rest}>
      <Monogram size={mono} />
      <div className="leading-none text-center">
        <span
          className={`font-display tracking-[0.32em] uppercase ${s.text}`}
          style={{
            background: "linear-gradient(135deg, #D6B16B 0%, #C8A063 50%, #B8924F 100%)",
            WebkitBackgroundClip: "text",
            backgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          Habano
        </span>
        {tag && (
          <div className={`${s.tag} mt-3 uppercase tracking-[0.32em] text-[#7E766D]`}>
            est. La Habana 2025
          </div>
        )}
      </div>
    </div>
  );
};

/**
 * Header wordmark — matches mockup exactly:
 *  [ ▢ H ]  HABANO
 *           A P P
 */
export const LogoMark = ({ className = "", iconOnly = false, boxed = true }) => {
  if (iconOnly) {
    return (
      <span className={`inline-flex items-center justify-center ${className}`}>
        {boxed ? <MonogramBoxed size={44} /> : <Monogram size={32} />}
      </span>
    );
  }
  return (
    <span className={`inline-flex items-center gap-3 ${className}`}>
      <MonogramBoxed size={48} />
      <span className="flex flex-col leading-none">
        <span
          className="font-display tracking-[0.32em] uppercase text-[1.35rem]"
          style={{
            background: "linear-gradient(135deg, #D6B16B 0%, #C8A063 50%, #B8924F 100%)",
            WebkitBackgroundClip: "text",
            backgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          Habano
        </span>
        <span className="text-[10px] mt-1.5 uppercase tracking-[0.4em] text-[#7E766D]">
          App
        </span>
      </span>
    </span>
  );
};

export { Monogram };
export default Logo;
